import { useState, type Ref } from 'react'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'

import { Typography } from '@/src/elements/text/Typography'
import { CommentList } from '@/src/features/comment/ui/CommentList'
import { AuthenticationRequired } from '@/src/general/components/AuthenticationRequired'

import { CommentTextarea } from './CommentTextarea'

type TCommentSectionProps = {
  publicationId: number
  communityId: number
  commentsCount: number
  show?: boolean
  autofocus?: boolean
  ref?: Ref<View>
}

export const CommentSection = ({
  ref,
  publicationId,
  communityId,
  commentsCount,
  show = false,
  autofocus = false,
}: TCommentSectionProps) => {
  const [showComments, setShowComments] = useState(show)

  const handleShowCommentPressed = () => {
    setShowComments(true)
  }

  return (
    <View ref={ref}>
      <Typography size="sm" className="mt-6">
        <FormattedMessage id="publication.comment.title" values={{ count: commentsCount }} />
      </Typography>
      <AuthenticationRequired>
        <CommentTextarea
          publicationId={publicationId}
          communityId={communityId}
          objectType="publication"
          onSubmitComment={handleShowCommentPressed}
          autofocus={autofocus}
        />
      </AuthenticationRequired>
      <CommentList
        publicationId={publicationId}
        showComments={showComments}
        onShowCommentPressed={handleShowCommentPressed}
        commentsCount={commentsCount}
      />
    </View>
  )
}
